module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_HR-694955305ab615d42960481614c0a7de.svg";